import { render, staticRenderFns } from "./AdminSuperAssignPoints.vue?vue&type=template&id=6e3d7fd9&scoped=true&lang=pug&"
import script from "./AdminSuperAssignPoints.vue?vue&type=script&lang=js&"
export * from "./AdminSuperAssignPoints.vue?vue&type=script&lang=js&"
import style0 from "./AdminSuperAssignPoints.vue?vue&type=style&index=0&id=6e3d7fd9&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e3d7fd9",
  null
  
)

export default component.exports